<template>
  <div v-if="visible" id="Popup">
    <div class="popup">
      <div class="popup__card" :class="{opened}">
        <button type="button"
                class="popup__card__button"
                @click="close"
        >
          <IconCloseFat />
        </button>
        <div class="popup__card__content">
          <slot />
        </div>
      </div>
    </div>
    <div class="popup-backdrop"
         :class="{opened}"
         @click="close"
    />
  </div>
</template>
<script>
import IconCloseFat from "@/components/svg/IconCloseFat.vue";

export default {
  name: "Popup",
  components: {IconCloseFat},
  data() {
    return {
      cookieName: 'stegiRadioNewDomainPopup',
      cookieExpirationDays: 2,
      popupDelay: 5000,
      visible: false,
      opened: false,
      dateEnd: new Date('2023-10-15'), // after this date popup will be inactive
      dateNow: new Date()
    }
  },
  mounted() {
    if (!this.getCookie() && this.isPopupPeriodActive()) { // check if cookie has been registered and popup period is active
      setTimeout(() => {
        this.open();
      }, this.popupDelay);
    }
  },

  methods: {
    open() {
      this.visible = true;
      setTimeout(() => {
        this.opened = true;
      }, 500);
    },
    close() {
      this.registerCookie();
      this.opened = false;
      setTimeout(() => {
        this.visible = false;
      }, 500);
    },
    getCookie() {
      return document.cookie.split("; ").find((row) => row.startsWith(this.cookieName));
    },
    registerCookie() {
      document.cookie = `${this.cookieName}=true; expires=${this.getCookieExpireDate()}; SameSite=None; Secure`;
    },
    getCookieExpireDate() {
      const date = new Date();
      date.setDate(date.getDate() + this.cookieExpirationDays);
      return date.toUTCString();
    },
    isPopupPeriodActive() {
      return this.dateEnd > this.dateNow;
    }
  }


}
</script>
<style scoped lang="scss">
@import "@/assets/sass/abstracts/variables";

.popup-backdrop {
  background-color: rgba(0, 0, 0, 0.18);
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8887;
  backdrop-filter: brightness(.5);
  opacity: 0;
  transition: opacity .4s ease;

  &.opened {
    opacity: 1;
  }
}

.popup {
  background-color: transparent;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  z-index: 8888;
  display: flex;
  justify-content: center;
  align-items: center;
  pointer-events: none;

  &__card {
    width: 100%;
    max-width: 768px;
    min-height: 200px;
    background-color: $c_base;
    border-radius: 24px;
    padding: 45px 40px;
    position: relative;
    pointer-events: all;
    opacity: 0;
    transition: all .6s ease;
    transform: translateY(-60px);

    &.opened {
      opacity: 1;
      transform: translateY(0);
    }

    &__content {
      color: $c_white;
      @include font-24-md;
      padding-right: 20px;
    }

    &__button {
      background-color: $c_black;
      border-radius: 50%;
      border: none;
      padding: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      position: absolute;
      right: 20px;
      top: 20px;

      &:hover {
        opacity: .5;
      }

      svg {
        transform: rotate(45deg);
        width: 12px;
        height: 12px;
        fill: $c_white;
      }
    }
  }
}
</style>
